import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PersonalInfoChild from './PersonalInfoChildComponent';

const mapStateToProps = (/* , props */) => ({});

const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PersonalInfoChild));
